import * as Yup from "yup";
import i18n from "../i18n";
import { WarehouseWorkersAttachments } from "../constants/common";

export const createAccompanyingPersonnelDetailsGroupCardSchema = (
  isAttachments: WarehouseWorkersAttachments
) => {
  return Yup.object({
    name: Yup.string()
      .required(i18n.language === "en" ? "Name is required." : "الاسم مطلوب.")
      .matches(
        /^[^0-9]*$/,
        i18n.language === "en"
          ? "Name must not contain numbers."
          : "يجب ألا يحتوي الاسم على أرقام."
      ),

    nationality: Yup.string().required(
      i18n.language === "en" ? "Nationality is required." : "الجنسية مطلوبة."
    ),

    residencePermitNo: Yup.string().required(
      i18n.language === "en"
        ? "Residence permit no. is required."
        : "رقم تصريح الإقامة مطلوب."
    ),

    issuingAuthority: Yup.string().required(
      i18n.language === "en"
        ? "Issuing authority is required."
        : "الجهة المصدرة مطلوبة."
    ),

    issueDate: Yup.string()
      .optional()
      .nullable()
      .required(
        i18n.language === "en"
          ? "Issue date is required."
          : "تاريخ انتهاء الهوية الوطنية مطلوب."
      ),

    uploadId: Yup.mixed().when([], {
      is: () => isAttachments?.haveId,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(
          i18n.language === "en"
            ? "ID upload is required."
            : "تحميل الهوية مطلوب."
        ),
    }),
  });
};
